import { Injectable } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { isDefined } from "../../shared/helpers";

@Injectable()
export class OidcService {
  openIdClientString = "";
  constructor(route: ActivatedRoute) {
    route.queryParamMap.subscribe((map) => {
      this.parseRoute(map);
    });
  }

  parseRoute(map: ParamMap) {
    const clientParamsList = ["client_id", "redirect_uri", "response_type", "scope", "code_challenge_method", "code_challenge", "nonce", "state"];
    const clientIdParam = clientParamsList[0];

    if (map.has(clientIdParam)) {
      this.openIdClientString = "";

      clientParamsList.forEach(paramName => {
        if (map.has(paramName)) {
          this.openIdClientString += `&${paramName}=${map.get(paramName)}`;
        }
      });
      if (this.openIdClientString.length > 0) {
        this.openIdClientString = this.openIdClientString.substring(1);
      }
    }
  }

  get isClientConfigAvailable(): boolean {
    return (isDefined(this.openIdClientString) && this.openIdClientString!.includes("client_id"));
  }
}

